import React, { useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';

import { loadStripe } from '../../../../stripe';

const SYSTEM_FONTS_URL =
  'https://fonts.googleapis.com/css2?family=Anton&family=Didact+Gothic&family=Fira+Sans&family=IBM+Plex+Sans:wght@500&family=Noto+Serif&family=Nunito&family=Fraunces&family=Outfit&family=Public+Sans&display=swap';
function withStripe(Component) {
  return function(props) {
    const { stripeUrl, stripeApiKey, fonts, stripeAccountId } = props;
    const customFonts = useMemo(() => {
      return fonts
        .filter(f => f.file_url)
        .map(f => ({
          family: f.font_family,
          src: `url(${f.file_url})`,
          weight: f.font_weights[0].toString(),
        }));
    }, [fonts]);

    const stripe = useMemo(() => loadStripe({ stripeUrl, stripeApiKey, stripeAccountId }), [
      stripeUrl,
      stripeApiKey,
    ]);
    const options = {
      theme: 'night',
      fonts: [
        {
          cssSrc: SYSTEM_FONTS_URL,
        },
        ...customFonts,
      ],
      appearance: {
        labels: 'floating',
      },
    };

    return (
      <Elements stripe={stripe} options={options}>
        <Component {...props} />
      </Elements>
    );
  };
}

export default withStripe;
